import {useI18n} from '@logistics-frontend/core/i18n'
import React from 'react'

import {DOWNLOAD_YANGO_APP} from './consts'
import {PromoProps} from './types'
import YangoPromoBase from './YangoPromoBase'

const YangoPromo: React.FC<PromoProps> = ({fullWidth, onClick}) => {
  const t = useI18n()

  return (
    <YangoPromoBase fullWidth={fullWidth} link={DOWNLOAD_YANGO_APP} onClick={onClick} text={t('route_promo_text')} />
  )
}

export default YangoPromo
